<div class="versions">
  <div>

    <h4>Data sources</h4>
    <div class="section-body">
      <ul>
        <li *ngFor="let nameVersion of dataSourceNameVersions">
          {{nameVersion[0]}}: {{nameVersion[1]}}
        </li>
      </ul>
    </div>
  </div>

  <div>
    <h4>Ontology and controlled vocabularies (CVs)</h4>
    <div class="section-body">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Version</th>
            <th></th>
          </tr>
        </thead>
        <tr *ngFor="let cvDetail of cvDetails">
          <td>{{cvDetail.cvName}}</td>
          <td>{{cvDetail.description}}</td>
          <td>{{cvDetail.version}}</td>
          <td class="external-link">
            <a *ngIf="cvDetail.externalLink" href="{{cvDetail.externalLink}}">source</a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
